import React, { useEffect, useState } from "react";
import { Form, Button, message, Popconfirm, Input } from "antd";
import { useParams } from "react-router-dom";
import FileUpload from "../../../Components/Uploader";
import { editArticleMainImage, getArticleByID } from "../action";

type Props = {
  onImageEdit: () => void;
};

interface FormData {
  alt: string;
  image: {
    fileuploaded: boolean;
    name: string;
    folder: string;
  };
}
const EditArticleImage = (props: Props) => {
  const { id } = useParams();
  const [form] = Form.useForm<FormData>();
  const [isLoading, setIsLoading] = useState(false);
  const [uploadedFile, setUploadedFile] = useState<{
    fileuploaded: boolean;
    name: string;
    folder: string;
  } | null>(null);

  const fetchData = () => {
    if (!id) return;

    getArticleByID(id).then((data) => {
      if (!data) return;
      setUploadedFile({
        fileuploaded: Boolean(data.MainImage.FilePath?.trim()),
        name: data.MainImage.FilePath,
        folder: "",
      });
      form.setFieldsValue({
        alt: data.MainImage.Alt,
        image: {
          fileuploaded: Boolean(data.MainImage.FilePath?.trim()),
          name: data.MainImage.FilePath,
          folder: "",
        },
      });
    });
  };
  useEffect(() => {
    fetchData();
  }, [id]);

  const handleFileUploaded = (fileData: {
    fileuploaded: boolean;
    name: string;
    folder: string;
  }) => {
    setUploadedFile(fileData);
    message.success("File data saved to the form!");
  };

  const handleSubmit = () => {
    form
      .validateFields()
      .then(async (values) => {
        if (!uploadedFile) {
          message.error("Please upload an image before submitting.");
          return;
        }

        const formData = {
          ...values,
          image: uploadedFile,
        };

        const response = await editArticleMainImage(
          id || "",
          formData.image.name,
          formData.alt
        );
        if (response) {
          message.success("Form submitted successfully!");
          props.onImageEdit();
        }
      })
      .catch((error) => {
        console.error("Validation failed:", error);
        message.error("Please correct the errors in the form.");
      });
  };

  return (
    <Form form={form} layout="vertical">
      <Form.Item label="Image" name="alt" required>
        <Input placeholder="Enter image alt" />
      </Form.Item>
      <Form.Item label="Article Image" required>
        <FileUpload onFileUploaded={handleFileUploaded} enableCrop />
      </Form.Item>

      <Form.Item>
        <Popconfirm
          title="Are you sure you want to modify image of this article?"
          onConfirm={handleSubmit}
          okText="Yes"
          cancelText="No"
        >
          <Button loading={isLoading} type="primary" className="w-full">
            {isLoading ? "Updating..." : "Update"}
          </Button>
        </Popconfirm>
      </Form.Item>
    </Form>
  );
};

export default EditArticleImage;
